export class PaginationConfig {
  predicate: string = 'id';
  ascending: boolean = true;
  page: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;
  maxSize: number = 8;
  itemsPerPageOptions: number[] = [10, 25, 50, 100];
}
